var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse, _path13, _rect, _rect2, _rect3, _rect4, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSelfieDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 95,
    viewBox: "0 0 80 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38901 40.3837L12.7729 43.6209L5.94336 46.7261L12.9454 52.7438L6.36957 54.0631L12.8034 59.9895C12.8034 59.9895 8.62241 62.6584 9.20084 62.8918C9.77927 63.1252 16.2333 68.6558 16.2333 68.6558L15.5331 39.2979L8.38901 40.3837Z",
    fill: "#E9EAEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6151 68.2395C59.5543 72.6843 51.1213 80.9853 43.6728 82.2335C36.2242 83.4817 13.7262 68.6454 14.1525 65.8547C14.5787 63.064 26.1473 40.0689 32.0534 41.3171C37.9595 42.5652 59.7166 60.7706 59.6151 68.2395Z",
    fill: "#E9EAEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6919 64.4302H43.8516L43.8516 12.351L13.6919 12.351L13.6919 64.4302Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7363 14.6384V67.7526C11.7363 69.2139 12.8627 70.4012 14.253 70.4012H43.2456C44.6359 70.4012 45.7623 69.2139 45.7623 67.7526V14.6384C45.7623 13.1771 44.6359 11.9897 43.2456 11.9897H14.2429C12.8526 11.9897 11.7363 13.1771 11.7363 14.6384ZM14.2835 15.4197H43.205L43.2456 61.3346H14.324L14.2835 15.4197Z",
    fill: "#DBDBDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46203 34.0207C9.94913 33.9598 12.7297 34.9543 12.7703 37.6536C12.8108 40.3428 10.3652 41.0735 9.46203 41.0836C8.54872 41.0836 7.47304 39.3179 7.41215 37.5522C7.36141 35.8575 8.28487 34.1628 9.46203 34.0207Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33659 34.6907C8.55985 34.6704 8.00171 35.949 8.02201 37.5524C8.0423 38.7904 8.63088 40.3025 8.38733 40.3836C7.99156 40.5054 7.23047 39.0949 7.23047 37.5524C7.23047 36.0099 7.89008 34.7313 8.33659 34.6907Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55373 41.571C10.0408 41.5101 12.8214 42.5046 12.862 45.2039C12.9025 47.8931 10.4569 48.6238 9.55373 48.6339C8.64042 48.6339 5.53516 47.8018 5.53516 45.3054C5.53516 43.0018 8.37657 41.713 9.55373 41.571Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42763 42.2405C8.65089 42.2202 8.09275 43.4988 8.11305 45.1022C8.13334 46.3402 8.72192 47.8523 8.47837 47.9335C8.0826 48.0552 6.875 46.6345 6.875 45.092C6.875 43.5394 7.98112 42.2709 8.42763 42.2405Z",
    fill: "#DBDBDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83001 49.314C10.2867 49.2632 12.915 50.1968 12.9556 52.744C12.9962 55.2911 10.6824 55.9811 9.83001 55.9811C8.96744 55.9811 5.94336 54.9867 5.94336 52.6425C5.94336 50.3693 8.71374 49.4459 9.83001 49.314Z",
    fill: "#F5F5F5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75252 49.9431C8.95548 49.9228 8.43794 51.1304 8.45823 52.6425C8.47853 53.8196 9.03667 55.2403 8.80326 55.3114C8.43794 55.4331 7.54492 54.0835 7.54492 52.6323C7.54492 51.1812 8.33646 49.9736 8.75252 49.9431Z",
    fill: "#DBDBDB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77526 56.6612C10.2218 56.6104 12.7587 57.5237 12.7993 59.9795C12.8399 62.4455 10.5972 63.1153 9.77526 63.1153C8.93298 63.1153 7.94863 61.5017 7.89789 59.8882C7.8573 58.3356 8.69958 56.7931 9.77526 56.6612Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74097 57.28C8.94393 57.2598 8.43653 58.4268 8.45683 59.8881C8.47713 61.0246 9.01497 62.4047 8.79171 62.4758C8.43653 62.5874 7.73633 61.2986 7.73633 59.8881C7.73633 58.4775 8.33506 57.3105 8.74097 57.28Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6049 62.5972L79.373 80.7112L50.5732 94.9995C50.5732 94.9995 43.3682 83.6744 41.643 82.2334C39.928 80.7924 59.6049 62.5972 59.6049 62.5972Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5734 94.9997C50.5734 94.9997 42.7493 83.6847 42.2013 82.9541C41.6534 82.2234 39.0859 81.6958 39.0859 81.6958L49.2034 72.6438L55.282 71.8726C55.282 71.8726 51.6085 73.8413 49.6499 77.0176C47.6914 80.1939 51.2837 85.623 53.5467 91.0724",
    fill: "#E9EAEB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6676,
    cy: 31.9295,
    rx: 6.99575,
    ry: 6.79863,
    fill: "#E9EAEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2646 53.3712C44.2704 53.2207 44.2733 53.0696 44.2733 52.9179C44.2733 45.6587 37.562 39.7739 29.2831 39.7739C21.0043 39.7739 14.293 45.6587 14.293 52.9179C14.293 53.0696 14.2959 53.2207 14.3017 53.3712H44.2646ZM29.3137 66.0619H29.2526C29.2628 66.062 29.273 66.062 29.2831 66.062C29.2933 66.062 29.3035 66.062 29.3137 66.0619Z",
    fill: "#E9EAEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0723,
    y: 12.4731,
    width: 7.37867,
    height: 1.84467,
    rx: 0.922334,
    transform: "rotate(-136.086 11.0723 12.4731)",
    fill: "#E9EAEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 10.4551,
    width: 7.37867,
    height: 1.84467,
    rx: 0.922334,
    transform: "rotate(-91.0856 14.293 10.4551)",
    fill: "#E9EAEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2617,
    y: 15.9736,
    width: 7.37867,
    height: 1.84467,
    rx: 0.922334,
    transform: "rotate(178.914 10.2617 15.9736)",
    fill: "#E9EAEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.291,
    y: 52.6611,
    width: 28.8045,
    height: 9.23503,
    fill: "#E9EAEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3352 41.9261C31.5631 41.5303 35.0946 40.1908 36.2007 40.2212C37.7736 40.2618 50.215 43.296 51.1689 44.2905C52.1228 45.285 59.8859 55.3822 59.6018 62.5974C59.3177 69.8126 54.7308 72.6438 53.097 73.0294C51.4632 73.4151 45.2222 72.522 43.2941 68.2092C41.1427 63.4092 42.9592 53.7788 42.4518 53.4338C38.4738 50.6431 37.3373 47.6799 36.7284 47.8727C36.1195 48.0656 32.2227 48.6643 29.7771 47.6901C27.0777 46.6246 25.0075 43.7933 25.7686 43.1032C26.5297 42.4132 28.6304 42.4741 30.3352 41.9261Z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7685 43.1032C26.073 43.4178 26.7732 43.9658 28.2142 43.8136C29.6552 43.6614 31.8065 42.951 31.8065 42.5654C31.8065 42.1798 31.086 41.6521 30.8323 41.7637C30.5786 41.8753 25.4235 42.7481 25.7685 43.1032Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSelfieDisabled);
export default __webpack_public_path__ + "static/media/img_selfie_disabled.46990473c507798d081c2f57c3c061ba.svg";
export { ForwardRef as ReactComponent };